import { ref, watch, computed } from "@vue/composition-api"

export default function useContractsList() {

  const refUserListTable = ref(null)

  const perPage = ref(50)
  const totalUsers = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 50, 100, 200, 300, 500, 800, 1000, 2000]
  const searchQuery = ref("")
  const sortBy = ref("id")
  const isSortDirDesc = ref(true)

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value
      ? refUserListTable.value.localItems.length
      : 0
    
    return {
      from:
                perPage.value * (currentPage.value - 1) +
                (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUsers.value,
    }
  })

  const refetchData = () => {
    refUserListTable.value.refresh()
  }

  watch(
    [
      currentPage,
      perPage,
      searchQuery,
    ],
    () => {
      refetchData()
    },
  )

  return {
    perPage,
    currentPage,
    totalUsers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,

    refetchData,

  }
}
